import { ENTITY_ITEMS_DROPDOWN_LIMIT } from '@/_legacy/constants';
import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { SelectOptions } from '@/ui/types';
import { TagField } from '@/ui/components/form';
import { ValidationError } from '@/entities/validation';
import { VDataComponents } from '@/ui/helpers';

interface ChooseEntityItemFieldProps {
  options: SelectOptions;
  value: number[];
  errors: ValidationError[];
  disabled?: boolean;
  required?: boolean;
  label?: string;
  placeholder?: string;
  identifier?: string;
  hideLabel?: boolean;
}

export const ChooseEntityItemField = defineComponent<ChooseEntityItemFieldProps>({
  props: ['options', 'value', 'errors', 'label', 'placeholder', 'identifier', 'hideLabel', 'required'],
  setup(props, ctx) {
    return function render() {
      return h('div', { class: 'field choose-entity-items-field' }, [
        h(TagField, {
          props: {
            value: props.value,
            options: props.options,
            disabled: false,
            placeholder: props.placeholder ?? t('entity-folder.enter-entity-items'),
            label: props.label ?? t('common.entity-items'),
            name: 'entityItems',
            required: props.required,
            errors: props.errors,
            hideLabel: props.hideLabel,
            maxListedOptions: ENTITY_ITEMS_DROPDOWN_LIMIT,
          },
          scopedSlots: {
            ...ctx.slots,
            header: ctx.slots.beforeList,
          },
          on: {
            input: (value: Array<string | number>) => ctx.emit('input', value),
          },
        }),
      ]);
    };
  },
});

export const chooseEntityItemField = (data: VDataComponents<ChooseEntityItemFieldProps>) => h(ChooseEntityItemField, data);
